import { createFileRoute } from "@tanstack/react-router";
import { UsagePage } from "../components/usage/UsagePage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";
import { strings } from "../lib/strings";

/** Settings › Usage (BUILD_SPEC §7.4), for the workspace's Administrators. */
function UsageRoute() {
  const view = useWorkspace(workspaceSlug());
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <AdministratorsOnly what={strings.states.adminPages.usage} />;
  return <UsagePage />;
}

export const Route = createFileRoute("/admin/settings/usage")({ component: UsageRoute });
